<template>
  <div class="timer-wrapper">
    <div class="time">
      <div class="countdown" id="countdown">
        <span class="hours">{{ String(h).length>=2 ? h :'0'+h }}</span>
        <div>:</div>
        <span class="minutes">{{ String(m).length>=2 ? m : '0'+m }}</span>
        <div>:</div>
        <span class="seconds">{{ String(s).length>=2 ? s :'0'+s }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    props:['h','m','s'],
    data(){
      return {

      }
    }
  }
</script>
<style scoped lang="less">
  .timer-wrapper {
    width: 100%;
  }
  #countdown{
    display: flex;
    flex-direction: row;
    justify-content: center;
    div, span {
      line-height: 20px;
      color: #fff;
      font-size: 14px;
    }
    span {
      background: #222;
      display: inline-block;
      padding: 4px;
      margin: 0 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// counter.vue?5babc7b0